import { Alert, Button, Card, Form, Input, Space, Typography } from 'antd';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth.js';

export function LoginPage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const returnTo = (location.state as { returnTo?: string } | null)?.returnTo ?? '/';
  return <main className="login-page">
    <Card className="login-card">
      <Space orientation="vertical" size={20} style={{ width: '100%' }}>
        <div><Typography.Title level={2}>售后 ERP</Typography.Title><Typography.Text type="secondary">使用已授权的企业账号登录</Typography.Text></div>
        {error ? <Alert type="error" showIcon title={error} /> : null}
        <Form layout="vertical" onFinish={(values: { username: string; password: string }) => {
          setSubmitting(true); setError('');
          void auth.login(values.username, values.password).then(() => navigate(returnTo, { replace: true }))
            .catch((reason: unknown) => setError(reason instanceof Error ? reason.message : '登录失败')).finally(() => setSubmitting(false));
        }}>
          <Form.Item name="username" label="用户名" rules={[{ required: true, message: '请输入用户名' }]}><Input autoComplete="username" /></Form.Item>
          <Form.Item name="password" label="密码" rules={[{ required: true, message: '请输入密码' }]}><Input.Password autoComplete="current-password" /></Form.Item>
          <Button type="primary" htmlType="submit" block loading={submitting}>登录</Button>
        </Form>
      </Space>
    </Card>
  </main>;
}
